import React, { useState, useRef } from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'
import { t } from '@lingui/macro'
import LocalisedImage from '../common/LocalisedImage'
import VerifiedBy from '../common/typography/VerifiedBy'
import './AppPreview.scss'

const AppPreview = ({ verified, appName, appLogoUrl }) => {
  const [hasCheckedImageSize, setHasCheckedImageSize] = useState(false)
  const [isImageValid, setIsImageValid] = useState(false)
  const testImageRef = useRef()


  const checkImageSize = () => {
    if (testImageRef.current) {
      const { naturalWidth, naturalHeight } = testImageRef.current
      const imageValid = Math.min(naturalWidth, naturalHeight) > 10
      setIsImageValid(imageValid)
    }
    setHasCheckedImageSize(true)
  }

  const appLogoClassName = classNames('app-logo', {
    'app-logo--removed': (hasCheckedImageSize && !isImageValid),
    'app-logo--revealed': isImageValid
  })

  const imageClassName = classNames('app-logo__image', {
    'app-logo__image--hidden': !isImageValid
  })

  return (
   <>
     <div className={appLogoClassName}>
       {
         !hasCheckedImageSize
         && <img className="app-logo__test-image" alt="" ref={testImageRef} src={appLogoUrl} onLoad={checkImageSize} />
       }
       <LocalisedImage src={appLogoUrl} alt={t`Application Logo`} className={imageClassName} />
     </div>
     <div className="app-name">{appName}</div>
     { verified && <VerifiedBy />}
   </>
  )
}

AppPreview.propTypes = {
  verified: PropTypes.bool.isRequired,
  appName: PropTypes.string.isRequired,
  appLogoUrl: PropTypes.string,
}

export default AppPreview
